export default "__VITE_ASSET__C_3uhD5a__"